import { Suspense, type FunctionComponent, type RefObject } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useFeatureGate } from '@trello/feature-gate-client';
import { useLazyComponent } from '@trello/use-lazy-component';

import { StubPlanner } from './StubPlanner';

export const LazyPlanner: FunctionComponent<{
  screenManagerRef: RefObject<HTMLDivElement>;
}> = ({ screenManagerRef }) => {
  const { value: isPlannerEnabled } = useFeatureGate('xf_fg_planner');

  const Planner = useLazyComponent(
    () => import(/* webpackChunkName: "planner" */ './Planner'),
    { namedImport: 'Planner' },
  );

  if (!isPlannerEnabled) {
    return <StubPlanner />;
  }

  return (
    <ErrorBoundary>
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <Planner screenManagerRef={screenManagerRef} />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
